import axios from 'axios';
import ConfigService from '../config';
import { historyReplace } from '../common/history';

export default class HttpService {
  static get = async (url, isAuth) => {
    url = ConfigService.BASE_URL + url;

    const headers = { 'Content-Type': 'application/json' };
    if (isAuth) {
      const token = localStorage.getItem('personal-account.token');
      if (!token) return null;

      headers.Authorization = `Bearer ${token}`;
    }

    try {
      return await axios.get(url, { headers });
    } catch (e) {
      return { status: undefined, data: { message: 'Network Error' } };
    }
  };

  static post = async (url, payload, isAuth) => {
    url = ConfigService.BASE_URL + url;

    const headers = { 'Content-Type': 'application/json' };
    if (isAuth) {
      const token = localStorage.getItem('personal-account.token');
      if (!token) return null;

      headers.Authorization = `Bearer ${token}`;
    }

    try {
      return await axios.post(url, payload, { headers });
    } catch (e) {
      return { status: undefined, data: { message: 'Network Error' } };
    }
  };

  static put = async (url, payload, isAuth) => {
    url = ConfigService.BASE_URL + url;
    const headers = { 'Content-Type': 'application/json' };
    if (isAuth) {
      const token = localStorage.getItem('personal-account.token');
      if (!token) return null;

      headers.Authorization = `Bearer ${token}`;
    }

    try {
      return await axios.put(url, payload, { headers });
    } catch (e) {
      return { status: undefined, data: { message: 'Network Error' } };
    }
  };

  static delete = async (url, isAuth) => {
    url = ConfigService.BASE_URL + url;
    const headers = { 'Content-Type': 'application/json' };
    if (isAuth) {
      const token = localStorage.getItem('personal-account.token');
      if (!token) return null;

      headers.Authorization = `Bearer ${token}`;
    }

    try {
      return await axios.delete(url, { headers });
    } catch (e) {
      return { status: undefined, data: { message: 'Network Error' } };
    }
  };
}
